import { Component, Input } from '@angular/core';
import { ReferenceDataLabels } from '../../constants/reference-data-labels';
import { ReferenceDataOptionLists } from '../../constants/reference-data-option-lists';
import { CaseRequestDto } from '../../models/dto/case-overview/case-request-dto.model';

@Component({
  selector: 'boi-case-request-status-history',
  templateUrl: './case-request-status-history.component.html',
  styleUrls: ['./case-request-status-history.component.scss']
})
export class CaseRequestStatusHistoryComponent {
  @Input() public caseRequest: CaseRequestDto;

  public pipeSymbol = '|';

  public referenceDataLabels = ReferenceDataLabels;
  public referenceDataOptionLists = ReferenceDataOptionLists;
}
